<template>
  <b-overlay
    variant="white"
    :show="showActivateLoading"
    spinner-variant="primary"
    blur="0"
    opacity=".75"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-spinner class="mb-2" />
        <p>
          Формируем страницы...
        </p>
      </div>
    </template>
    <div v-if="complete">
      <b-card class="py-5">
        <div class="w-100 col-lg-5 ml-auto mr-auto text-center">
          <div class="mb-1">
            <svg
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M76.6663 40V37C76.6663 35 75.333 33.6667 73.333 33.6667C71.333 33.6667 69.9997 35 69.9997 37V40C69.9997 56.6667 56.6663 70 39.9997 70C23.333 70 9.99967 56.6667 9.99967 40C9.99967 23.3333 23.333 10 39.9997 10C44.333 10 48.333 11 52.333 12.6667C53.9997 13.3333 55.9997 12.6667 56.6663 11C57.333 9.33333 56.6663 7.33334 54.9997 6.66667C50.333 4.33334 44.9997 3.33334 39.9997 3.33334C19.6663 3.33334 3.33301 19.6667 3.33301 40C3.33301 60.3333 19.6663 76.6667 39.9997 76.6667C60.333 76.6667 76.6663 60.3333 76.6663 40ZM74.333 7.66667C75.6663 6.33334 77.6663 6.33334 78.9997 7.66667C80.333 9 80.333 11 78.9997 12.3333L42.333 49C41.6663 49.6667 40.6663 50 39.9997 50C39.333 50 38.333 49.6667 37.6663 49L27.6663 39C26.333 37.6667 26.333 35.6667 27.6663 34.3333C28.9997 33 30.9997 33 32.333 34.3333L39.9997 42L74.333 7.66667Z"
                fill="black"
              />
              <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="3"
                y="3"
                width="77"
                height="74"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M76.6663 40V37C76.6663 35 75.333 33.6667 73.333 33.6667C71.333 33.6667 69.9997 35 69.9997 37V40C69.9997 56.6667 56.6663 70 39.9997 70C23.333 70 9.99967 56.6667 9.99967 40C9.99967 23.3333 23.333 10 39.9997 10C44.333 10 48.333 11 52.333 12.6667C53.9997 13.3333 55.9997 12.6667 56.6663 11C57.333 9.33333 56.6663 7.33334 54.9997 6.66667C50.333 4.33334 44.9997 3.33334 39.9997 3.33334C19.6663 3.33334 3.33301 19.6667 3.33301 40C3.33301 60.3333 19.6663 76.6667 39.9997 76.6667C60.333 76.6667 76.6663 60.3333 76.6663 40ZM74.333 7.66667C75.6663 6.33334 77.6663 6.33334 78.9997 7.66667C80.333 9 80.333 11 78.9997 12.3333L42.333 49C41.6663 49.6667 40.6663 50 39.9997 50C39.333 50 38.333 49.6667 37.6663 49L27.6663 39C26.333 37.6667 26.333 35.6667 27.6663 34.3333C28.9997 33 30.9997 33 32.333 34.3333L39.9997 42L74.333 7.66667Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0)">
                <rect
                  width="80"
                  height="80"
                  fill="#28C76F"
                />
              </g>
            </svg>
          </div>
          <div class="h2">
            Страницы Успешно сформированы
          </div>
        </div>
      </b-card>
    </div>
    <div v-else>
      <form-wizard
        :title="null"
        :subtitle="null"
        color="#5E50EE"
        finish-button-text="Готово"
        back-button-text="Назад"
        next-button-text="Продолжить"
        @on-complete="onComplete"
      >
        <tab-content
          title="Сервис"
          :before-change="validateFirstStep"
        >
          <first-step
            v-if="readyStepsToInit.includes(1)"
            ref="firstStep"
          />
        </tab-content>
        <tab-content
          title="Бренды авто"
          :before-change="validateSecondStep"
        >
          <second-step
            v-if="readyStepsToInit.includes(2)"
            ref="secondStep"
          />
        </tab-content>
        <tab-content
          title="Услуги"
          :before-change="validateThirdStep"
        >
          <third-step
            v-if="readyStepsToInit.includes(3)"
            ref="thirdStep"
          />
        </tab-content>
      </form-wizard>
    </div>
  </b-overlay>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { BCard, BSpinner, BOverlay } from 'bootstrap-vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import Site from '@/api/http/models/site/site/Site'
import { mapGetters, mapActions } from 'vuex'
import FirstStep from './first/FirstStep.vue'
import SecondStep from './second/SecondStep.vue'
import ThirdStep from './third/ThirdStep.vue'

export default {
  components: {
    BCard,
    FormWizard,
    TabContent,
    BSpinner,
    BOverlay,
    FirstStep,
    SecondStep,
    ThirdStep,
  },
  data() {
    return {
      firstStepSuccess: false,
      secondStepSuccess: false,
      thirdStepSuccess: false,
      readyStepsToInit: [1],
      showActivateLoading: false,
      complete: false,
    }
  },
  computed: {
    ...mapGetters({
      currentSite: 'user/currentSite',
    }),
  },
  methods: {
    ...mapActions({
      fetchCurrentUser: 'user/FETCH_CURRENT_USER',
    }),
    async validateFirstStep() {
      const result = await this.$refs.firstStep.handleSubmit()
      if (result) {
        this.readyStepsToInit.push(2)
        return true
      }

      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Заполните поля',
          icon: 'AlertCircleIcon',
          variant: 'danger',
        },
      })

      return false
    },
    async validateSecondStep() {
      const result = await this.$refs.secondStep.handleSubmit()
      if (result) {
        this.readyStepsToInit.push(3)
        return true
      }

      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Выберите бренды',
          icon: 'AlertCircleIcon',
          variant: 'danger',
        },
      })

      return false
    },

    async validateThirdStep() {
      const result = await this.$refs.thirdStep.handleSubmit()

      if (result) {
        this.showActivateLoading = true
        const response = await Site.activate(this.currentSite.slug)
        if (response.status === 'success') {
          await this.fetchCurrentUser()
          this.showActivateLoading = false
        }
        return true
      }

      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Выберите услуги',
          icon: 'AlertCircleIcon',
          variant: 'danger',
        },
      })

      return false
    },

    onComplete() {
      this.complete = true
    },
  },
}
</script>

<style lang="scss">
  @import '~vue-form-wizard/dist/vue-form-wizard.min.css';
  @import '@core/scss/vue/libs/vue-wizard.scss';
</style>
